import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";

export class BusinessUnitSyncAlertIcon extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        return (
            <div className="bu-cell-button">
                <button className={this.cssClassName()} onClick={this.handleClick}>
                    <FaIcon type="button" iconName="sync-alt" spin={this.props.isBeingSyncedOnDemand}/>
                </button>
                <div className="bu-tooltip">
                    <button className={this.cssClassName()} onClick={this.handleClick}>
                        <FaIcon type="button" iconName="sync-alt" spin={this.props.isBeingSyncedOnDemand}/>
                    </button>
                    <p className="tooltip-description">
                        {this.props.message}
                    </p>
                </div>
            </div>
        )
    }

    handleClick() {
        this.props.onClick()
    }

    cssClassName() {
        if (this.props.hasSyncProblems) {
            return "sync-problems"
        } else if (!this.props.isOnSync) {
            return "not-synced"
        } else {
            return "synced"
        }
    }
}